import React from 'react'
import './Heading_title.css'

const Heading_title = (props) => {
    return (
        <>
            <section className='Heading_title_sec'>
                <p className='title headtitle'>{props.title}</p>
                <h2 className='headesubtitle'>{props.subtitle}</h2>
            </section>
        </>
    )
}

export default Heading_title